import { fixFloat } from './fix-float.js';
import { toNumber } from './to-number.js';
export const ceilToDecimalPlaces = (input, precision) => {
    const num = toNumber(input);
    const exp = Math.pow(10, precision);
    return fixFloat(Math.ceil(num * exp) / exp);
};
//# sourceMappingURL=ceil-to-decimal-places.js.map